import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CustomEventService } from '@shared/services/custom-event.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { validateFormGroup } from '@shared/utils/form.util';
import { PropertiesService } from "@core/services/properties.service";

@Component({
  selector: 'app-add-kpi-modal',
  templateUrl: './add-kpi-modal.component.html'
})
export class AddKpiModalComponent implements OnInit {

  @Input() loading: boolean;
  @Input() mode: 'edit' | 'add';
  @Input() data;
  @Input() title: string;
  @Input() groups: LeagueGroup.GroupModel[];

  addKPIForm: FormGroup;

  constructor(private customEventService: CustomEventService,
              public propertiesService: PropertiesService,
              private fb: FormBuilder) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    const { id = null, text = '', description = '', group = {} } = this.data;

    this.addKPIForm = this.fb.group({
      id: [id, []],
      text: [text, [Validators.required, Validators.minLength(5)]],
      description: [description, []],
      group: [group.key, []],
    });
  }

  submitForm(): void {
    validateFormGroup(this.addKPIForm);

    if (this.addKPIForm.invalid) {
      return;
    }

    const formData = this.addKPIForm.value;

    this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_KPI : ActionTypesEnum.UPDATE_KPI, formData);
  }

  resetForm(): void {
    this.createForm();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }
}
